import { ReactElement } from 'react'
import DevelopusTreeTableCell, {
  DevelopusTreeTableItemCellType,
} from './DevelopusTreeTableCell'
import { TableCell, TableHead, TableRow } from '@mui/material'

export type DevelopusTreeTableHeadType = {
  cells: DevelopusTreeTableItemCellType[]
}

interface Props {
  head: DevelopusTreeTableHeadType
}

const DevelopusTreeTableHead = (props: Props): ReactElement => {
  const { cells } = props.head

  return (
    <TableHead>
      <TableRow>
        <TableCell />
        {cells.map((cell, idx) => (
          <DevelopusTreeTableCell key={idx} cell={cell} />
        ))}
        <TableCell />
      </TableRow>
    </TableHead>
  )
}

export default DevelopusTreeTableHead
